import { Agent } from './../model/Agent';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'unregisteredAgent',
    standalone: false
})
export class UnregisteredAgentPipe implements PipeTransform {

  transform(agents: Agent[]): Agent[] {
    return agents ? agents.filter(agent => !agent.isAuthorized) : [];
  }

}
